import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NewsCarouselContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public buildResponseNewsCarousel(data) {
    data.news = this.getHighlightNews(data.max).toPromise();
    return data;
  }

  private getHighlightNews(top) {
    const params = {
      query: this.highlightNewsQuery(top, 'data/Data/iv desc')
    };

    return this.send(params).pipe(
      map(value => {
        return value.data.queryNoticiasContents.map(response => {
          const configs = response.data;
          return {
            id: response.id,
            title: configs.titulo ? configs.titulo.iv : '',
            description: configs.subtitulo ? configs.subtitulo.iv : '',
            banner:
              configs.imagemDestaque &&
              configs.imagemDestaque.iv &&
              configs.imagemDestaque.iv[0]
                ? configs.imagemDestaque.iv[0].url
                : '',
            date: configs.data ? configs.data.iv : '',
            slug: configs.slug ? configs.slug.iv : '',
            category: configs.categoria ? configs.categoria.iv : ''
          } as {
            date: string;
            category: string;
            banner: string;
            slug: string;
            description: string;
            title: string;
            id: string;
          };
        });
      }),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }

  private highlightNewsQuery(top: number, order: string) {
    return `{
      queryNoticiasContents(top: ${top}, orderby: "${order}") {
        id
        data{
          titulo{iv}
          subtitulo{iv}
          imagemDestaque{iv{url}}
          data{iv}
          slug{iv}
          categoria{iv}
        }
      }
    }`;
  }
}
